import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// ─── Périmètre synchronisé (2026-10-27) ─────────────────────────────────────
// La sélection de sociétés (paramètre `societes` de l'adresse, lu par tous les
// rapports) suit d'une page à l'autre, comme un segment synchronisé de Power
// BI. Un seul état : l'adresse. Le champ « Concession groupée » de la barre
// de gauche et la section Sociétés du panneau de droite l'écrivent tous les
// deux ; les liens de navigation le recopient. Le dernier choix est mémorisé
// par plaque et rétabli à la première page de la session.

// Pages sans notion de société : le champ y est grisé, la sélection est
// conservée pour la page suivante.
export const SANS_SOCIETE = new Set(['marche', 'marche-analyse']);
const CLE = (branche) => `bi-perimetre-${branche}`;
let restaure = false;   // une seule restauration par session

const lire = (cle) => { try { return localStorage.getItem(cle) || ''; } catch (e) { return ''; } };
const ecrire = (cle, v) => { try { if (v) localStorage.setItem(cle, v); else localStorage.removeItem(cle); } catch (e) { /* navigation privée */ } };

// Lien interne qui garde la sélection courante. `path` peut porter sa propre
// requête (« /?branche=… »).
export function avecPerimetre(path, search) {
  const s = new URLSearchParams(search).get('societes');
  if (!s) return path;
  return `${path}${path.includes('?') ? '&' : '?'}societes=${encodeURIComponent(s)}`;
}

// Mémorise / rétablit la sélection. À appeler depuis un composant présent sur
// toutes les pages (la barre de gauche).
export function useSynchroPerimetre(branche, actif) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!branche || !actif) return;
    const p = new URLSearchParams(search);
    const courant = p.get('societes') || '';
    if (!restaure) {
      restaure = true;
      const memo = lire(CLE(branche));
      if (!courant && memo) {
        p.set('societes', memo);
        navigate({ pathname, search: `?${p.toString()}` }, { replace: true });
        return;
      }
    }
    // L'adresse fait foi : « Tout réinitialiser » (paramètre retiré) mémorise « Toutes ».
    ecrire(CLE(branche), courant === '__aucune__' ? '' : courant);
  }, [branche, actif, pathname, search, navigate]);
}
